export default "__VITE_ASSET__jAyq0kKx__"